import { Component, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { ToggleSwitchModule } from 'primeng/toggleswitch';

@Component({
    selector: 'app-toggle',
    standalone: true,
    imports: [ToggleSwitchModule, FormsModule],
    template: `
    <p-toggleswitch
      [(ngModel)]="value"
      [name]="name"
      [inputId]="inputId"
      [disabled]="disabled"
      [class]="class"
      [style]="color ? { '--p-toggleswitch-checked-background': color, '--p-toggleswitch-checked-hover-background': color } : null"
      (ngModelChange)="onValueChange($event)"
    />
  `,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ToggleComponent),
            multi: true
        }
    ]
})
export class ToggleComponent implements ControlValueAccessor {
    @Input() name: string = '';
    @Input() inputId: string = '';
    @Input() disabled: boolean = false;
    @Input() class: string = '';
    @Input() color: string = '#FF6A2A';
    @Output() onChange = new EventEmitter<boolean>();

    private _value: boolean = false;
    private onChangeCallback: (value: boolean) => void = () => { };
    private onTouchedCallback: () => void = () => { };

    get value(): boolean {
        return this._value;
    }

    set value(val: boolean) {
        this._value = val;
        this.onChangeCallback(val);
    }

    onValueChange(value: boolean): void {
        this.value = value;
        this.onChange.emit(value);
        this.onTouchedCallback();
    }

    // ControlValueAccessor implementation
    writeValue(value: boolean): void {
        this._value = value;
    }

    registerOnChange(fn: (value: boolean) => void): void {
        this.onChangeCallback = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouchedCallback = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }
}
